import { Component, type ErrorInfo, type ReactNode } from "react";
import { Alert, Box, Button, Typography } from "@mui/material";
import { ErrorOutlineRounded, Refresh } from "@mui/icons-material";

interface Props { children: ReactNode }
interface State { hasError: boolean; error: Error | null }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 4, textAlign: "center" }}>
          <ErrorOutlineRounded sx={{ fontSize: 64, color: "error.main", mb: 2 }} />
          <Typography variant="h6" gutterBottom>Something went wrong</Typography>
          <Alert severity="error" sx={{ mb: 3, textAlign: "left", maxWidth: 500, mx: "auto" }}>
            {this.state.error?.message}
          </Alert>
          <Button variant="contained" startIcon={<Refresh />} onClick={() => window.location.reload()}>
            Refresh Page
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
